<main>
  <item on:click="{() => {
    window.open('https://www.lookatthesepaws.com')
  }}">
    <row>
      <h1>Look at These Paws</h1>
      <img src="/images/latp.png"/>
    </row>
    <p>Dog-Scrolling is much better than Doom-Scrolling!</p>
    <p>Recent years on social media found me creating less and less worthwhile content, and
      simultaneously consuming more and more pointless drivel. <i>LookAtThesePaws</i> is my project to
      make something better.</p>
    <p>Just your pets. No ads or tracking. Timeline is posts from people you follow, in
      chronological order. Comments disabled (they don't exist!). Liking a post spreads joy,
      without contributing to a popularity contest.</p>
    <p>I'm still in private Beta with it, but click through right now anyway to see what it's
      about!</p>
    <h2>lookatthesepaws.com</h2>
  </item>

  <dividerLine/>

  <item on:click="{() => {
    window.open('https://github.com/ryancumley/rockslide')
  }}">
    <row>
      <h1>rock() ~>> slide()</h1>
      <img src="/images/rockslide.JPG"/>
    </row>
    <p>Lightweight tooling to help write your app/lambda/executable/whatever as collections
      of reactive streams</p>
    <p>While RSS may have its' origins in the huge distributed systems and back-end architectures of
      places like Netflix, it can be an extremely satisfying way to think about many of the other
      problems we all write code to solve</p>
    <p>Have you've ever spent days or weeks trying to reproduce that one weird edge case, ultimately
      to discover that your massive 3,000 line <code>UIViewController</code> had subtle bugs in
      state coordination between several toggles, a <code>UITableViewDataSource</code>, and an
      interruptible swipe gesture driven animation?</p>
    <p>If that's you, and you've never played with reactive streams or one-way data flow UI
      architectures before, you're in for a treat with <code>rockslide</code></p>

    <h2>github.com/ryancumley/rockslide</h2>
  </item>

  <dividerLine/>

</main>

<style>
  main {
    text-align: left;
    display: flex;
    flex-direction: column;
    width: 97%;
    max-width: 800px;
    margin-right: auto;
    margin-left: auto;
    padding-top: 2rem;
    padding-left: 1rem; padding-right: 1rem;
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width:none;
  }
  main::-webkit-scrollbar {
    display: none;
  }
  row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  item {
    padding-left: 2rem; padding-right: 2rem; padding-bottom: 2rem;
  }
  item:hover {
    box-shadow: -2px 9px 10px -4px #272d35, 0px -9px 10px -4px #272d35;
    border-radius: 8px;
    background-color: rgb(248,248,248);
  }
  img {
    max-width: 35%;
    height: auto;
    margin: 8px;
    -webkit-filter: drop-shadow(5px 7px 5px #272d35);
    filter: drop-shadow(5px 7px 5px #272d35);
  }
  dividerLine {
    background-color: rgba(107,118,141,0.3);
    width: 100%;
    height: 1px;
    margin-top: 150px;
    margin-bottom:30px;
  }
  h2 {
    font-size: 2.1rem;
  }
  h2:hover {
    color: blue;
    text-decoration: underline;
    cursor: pointer;
  }
  p {
    font-size: 1.2rem;
  }

  @media screen and (max-width: 1000px){
    h1 { font-size: 2.0rem; }
    h2 { font-size: 1.8rem; }
  }
  @media screen and (max-width: 600px){
    h1 { font-size: 1.7rem; }
    h2 { font-size: 1.4rem; }
  }
</style>